module.exports = __webpack_public_path__ + "assets/47041ef96542baa5d64c8a4fd91c3f08.svg";